import { useEffect, useRef, useState } from "react";
import queryString from "query-string";
import { EProcessStatus } from "enums";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { inhabitantsAPI } from "services/inhabitantsAPI";

import { Breadcrumbs, Loading, Page, Pagination } from "components";
import { Filters } from "./components";

export default function ListProcesses(props) {
  const breadcrumbs = [
    { name: "Home", to: "/" },
    { name: "Lista de Processamentos", to: "" },
  ];

  const filterInitialState = {
    status_name: null,
  };

  const [loading, setLoading] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [pagination, setPagination] = useState(getCurrentPagination());
  const [filters, setFilters] = useState({
    status_name: null,
  });
  const debounceTimer = useRef(null);

  function getCurrentPagination() {
    const params = queryString.parse(props.location.search);
    const page = (params.page && Number(params.page)) || 1;
    const per = (params.per && Number(params.per)) || 10;

    return { page, per };
  }

  const fetchData = async () => {
    setLoading(true);

    inhabitantsAPI
      .get("/file-processors", {
        params: {
          page: pagination.page,
          perPage: pagination.per,
          status_name: filters.status_name && filters.status_name.value,
        },
      })
      .then(({ data }) => {
        setProcesses(data.data);
      })
      .finally(() => setLoading(false));
  };

  function handleFiltersClean(event) {
    event.preventDefault();
    setFilters({ ...filterInitialState });
  }

  function handleFiltersChange(name, value) {
    setFilters((current) => ({ ...current, [name]: value }));
  }

  useEffect(() => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      fetchData();
    }, 250);

    return () => {
      clearTimeout(debounceTimer.current);
    };
  }, [filters]);

  useEffect(() => {
    const { page, per } = getCurrentPagination();

    if (page !== pagination.page || per !== pagination.per) {
      setPagination({ per, page });
    }

    fetchData();
  }, [pagination, props.location.search]);

  return (
    <>
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Processamentos</Page.Title>

        <Filters
          filters={filters}
          onChange={handleFiltersChange}
          onClean={handleFiltersClean}
        />

        <table className="table table-curved">
          <thead>
            <tr>
              <th>Nome do arquivo</th>
              <th>Autor</th>
              <th>Status</th>
              <th>Criado em</th>
              <th className="text-right">Ações</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan="10">
                  <Loading type="page" size="large" />
                </td>
              </tr>
            ) : !processes.length ? (
              <tr>
                <td className="text-center" colSpan="10">
                  Nenhum processamento encontrado!
                </td>
              </tr>
            ) : (
              processes.map((process, index) => {
                return (
                  <tr key={index}>
                    <td>{process.attributes.file.name}</td>
                    <td>{process.attributes.file.metadata.authorName}</td>
                    <td>{EProcessStatus[process.attributes.status_name]}</td>
                    <td>
                      {format(
                        new Date(process.attributes.created_at),
                        "dd/MM/yyyy HH:mm"
                      )}
                    </td>
                    <td className="text-right">
                      <Link
                        to={{
                          pathname: `/processes/${process.id}/show`,
                        }}
                        className="button-icon"
                      >
                        <span className="glyph glyph-eye" />
                      </Link>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>

          <tfoot>
            <tr>
              <th colSpan="8" />
            </tr>
          </tfoot>
        </table>

        <Pagination
          current={pagination.page}
          total={processes.length}
          {...props}
        />
      </Page>
    </>
  );
}
